"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.FilterBlockConfig = exports.APIBlockConfig = exports.DelayBlockConfig = exports.ActionBlockConfig = exports.ConditionalBranch = exports.IfElseBlock = exports.WorkflowBlock = exports.ScheduleTriggerConfig = exports.EntityTriggerConfig = exports.WorkflowTrigger = exports.WorkflowDocument = void 0;
var field_1 = require("../field");
var filter_1 = require("../filter");
var workflow_enums_1 = require("./workflow-enums");
// Base Workflow Document
var WorkflowDocument = /** @class */ (function () {
    function WorkflowDocument(id, name, description, is_enabled, created_on, created_by, updated_on, updated_by, trigger, blocks) {
        if (id === void 0) { id = ''; }
        if (name === void 0) { name = ''; }
        if (description === void 0) { description = ''; }
        if (is_enabled === void 0) { is_enabled = false; }
        if (created_on === void 0) { created_on = 0; }
        if (created_by === void 0) { created_by = ''; }
        if (updated_on === void 0) { updated_on = 0; }
        if (updated_by === void 0) { updated_by = ''; }
        if (trigger === void 0) { trigger = new WorkflowTrigger(); }
        if (blocks === void 0) { blocks = []; }
        this.id = id;
        this.name = name;
        this.description = description;
        this.is_enabled = is_enabled;
        this.created_on = created_on;
        this.created_by = created_by;
        this.updated_on = updated_on;
        this.updated_by = updated_by;
        this.trigger = trigger;
        this.blocks = blocks;
    }
    WorkflowDocument.fromJSON = function (json) {
        var workflow = new WorkflowDocument();
        if (json) {
            workflow.id = json.id || '';
            workflow.name = json.name || '';
            workflow.description = json.description || '';
            workflow.is_enabled = json.is_enabled !== undefined ? json.is_enabled : false;
            workflow.created_on = json.created_on || 0;
            workflow.created_by = json.created_by || '';
            workflow.updated_on = json.updated_on || 0;
            workflow.updated_by = json.updated_by || '';
            workflow.trigger = WorkflowTrigger.fromJSON(json.trigger);
            workflow.blocks = json.blocks ? json.blocks.map(function (block) { return WorkflowBlock.fromJSON(block); }) : [];
        }
        return workflow;
    };
    return WorkflowDocument;
}());
exports.WorkflowDocument = WorkflowDocument;
// Workflow Trigger
var WorkflowTrigger = /** @class */ (function () {
    function WorkflowTrigger(type, config) {
        if (type === void 0) { type = workflow_enums_1.TriggerType.CONTACT_CREATED; }
        if (config === void 0) { config = new EntityTriggerConfig(); }
        this.type = type;
        this.config = config;
    }
    WorkflowTrigger.fromJSON = function (json) {
        var trigger = new WorkflowTrigger();
        if (json) {
            trigger.type = json.type || workflow_enums_1.TriggerType.CONTACT_CREATED;
            trigger.config = json.type === workflow_enums_1.TriggerType.SCHEDULE
                ? ScheduleTriggerConfig.fromJSON(json.config)
                : EntityTriggerConfig.fromJSON(json.config);
        }
        return trigger;
    };
    return WorkflowTrigger;
}());
exports.WorkflowTrigger = WorkflowTrigger;
// Entity Trigger Config
var EntityTriggerConfig = /** @class */ (function () {
    function EntityTriggerConfig(entity_type, event_type, activity_type, filter_groups) {
        if (entity_type === void 0) { entity_type = field_1.EntityType.CONTACT; }
        if (event_type === void 0) { event_type = workflow_enums_1.EventType.CREATE; }
        if (activity_type === void 0) { activity_type = ''; }
        if (filter_groups === void 0) { filter_groups = new filter_1.FilterGroup(filter_1.LogicOperator.AND); }
        this.entity_type = entity_type;
        this.event_type = event_type;
        this.activity_type = activity_type;
        this.filter_groups = filter_groups;
    }
    EntityTriggerConfig.fromJSON = function (json) {
        var config = new EntityTriggerConfig();
        if (json) {
            config.entity_type = json.entity_type || field_1.EntityType.CONTACT;
            config.event_type = json.event_type || workflow_enums_1.EventType.CREATE;
            config.activity_type = json.activity_type || '';
            config.filter_groups = json.filter_groups ? filter_1.FilterGroup.fromJSON(json.filter_groups) : new filter_1.FilterGroup(filter_1.LogicOperator.AND);
        }
        return config;
    };
    return EntityTriggerConfig;
}());
exports.EntityTriggerConfig = EntityTriggerConfig;
// Schedule Trigger Config
var ScheduleTriggerConfig = /** @class */ (function () {
    function ScheduleTriggerConfig(frequency, start_date, time, timezone) {
        if (frequency === void 0) { frequency = workflow_enums_1.ScheduleFrequency.DAILY; }
        if (start_date === void 0) { start_date = ''; }
        if (time === void 0) { time = '09:00'; }
        if (timezone === void 0) { timezone = 'UTC'; }
        this.frequency = frequency;
        this.start_date = start_date;
        this.time = time;
        this.timezone = timezone;
    }
    ScheduleTriggerConfig.fromJSON = function (json) {
        var config = new ScheduleTriggerConfig();
        if (json) {
            config.frequency = json.frequency || workflow_enums_1.ScheduleFrequency.DAILY;
            config.start_date = json.start_date || '';
            config.time = json.time || '09:00';
            config.timezone = json.timezone || 'UTC';
        }
        return config;
    };
    return ScheduleTriggerConfig;
}());
exports.ScheduleTriggerConfig = ScheduleTriggerConfig;
// Base Workflow Block
var WorkflowBlock = /** @class */ (function () {
    function WorkflowBlock(id, type, order, config) {
        if (id === void 0) { id = ''; }
        if (type === void 0) { type = workflow_enums_1.WorkflowBlockType.ACTION; }
        if (order === void 0) { order = 0; }
        if (config === void 0) { config = null; }
        this.id = id;
        this.type = type;
        this.order = order;
        this.config = config;
    }
    WorkflowBlock.fromJSON = function (json) {
        if (json.type === workflow_enums_1.WorkflowBlockType.IF_ELSE) {
            return IfElseBlock.fromJSON(json);
        }
        var block = new WorkflowBlock();
        if (json) {
            block.id = json.id || '';
            block.type = json.type || workflow_enums_1.WorkflowBlockType.ACTION;
            block.order = json.order || 0;
            block.config = json.config || {};
        }
        return block;
    };
    return WorkflowBlock;
}());
exports.WorkflowBlock = WorkflowBlock;
// If-Else Block (Special block type)
var IfElseBlock = /** @class */ (function (_super) {
    __extends(IfElseBlock, _super);
    function IfElseBlock(id, order, branches) {
        if (id === void 0) { id = ''; }
        if (order === void 0) { order = 0; }
        if (branches === void 0) { branches = [new ConditionalBranch(workflow_enums_1.BranchType.IF)]; }
        var _this = _super.call(this, id, workflow_enums_1.WorkflowBlockType.IF_ELSE, order) || this;
        _this.branches = branches;
        return _this;
    }
    IfElseBlock.fromJSON = function (json) {
        var block = new IfElseBlock();
        if (json) {
            block.id = json.id || '';
            block.order = json.order || 0;
            block.branches = json.branches ?
                json.branches.map(function (b) { return ConditionalBranch.fromJSON(b); }) :
                [new ConditionalBranch(workflow_enums_1.BranchType.IF)];
        }
        return block;
    };
    return IfElseBlock;
}(WorkflowBlock));
exports.IfElseBlock = IfElseBlock;
// Conditional Branch
var ConditionalBranch = /** @class */ (function () {
    function ConditionalBranch(type, filter_groups, blocks, id) {
        if (type === void 0) { type = workflow_enums_1.BranchType.IF; }
        if (filter_groups === void 0) { filter_groups = new filter_1.FilterGroup(filter_1.LogicOperator.AND); }
        if (blocks === void 0) { blocks = []; }
        if (id === void 0) { id = ''; }
        this.type = type;
        this.filter_groups = filter_groups;
        this.blocks = blocks;
        this.id = id;
        this.id = this.id || this.generateId();
    }
    ConditionalBranch.prototype.generateId = function () {
        return 'branch_' + Math.random().toString(36).substr(2, 9);
    };
    ConditionalBranch.fromJSON = function (json) {
        var branch = new ConditionalBranch();
        if (json) {
            branch.type = json.type || workflow_enums_1.BranchType.IF;
            branch.filter_groups = json.filter_groups ? filter_1.FilterGroup.fromJSON(json.filter_groups) : new filter_1.FilterGroup(filter_1.LogicOperator.AND);
            branch.blocks = json.blocks ? json.blocks.map(function (b) { return WorkflowBlock.fromJSON(b); }) : [];
            branch.id = json.id || branch.generateId();
        }
        return branch;
    };
    return ConditionalBranch;
}());
exports.ConditionalBranch = ConditionalBranch;
// Block Configuration Classes
var ActionBlockConfig = /** @class */ (function () {
    function ActionBlockConfig(action_type, activity_type, 
    // public template: { [key: string]: any } = {},
    field_mappings, target_entity_ref) {
        if (action_type === void 0) { action_type = workflow_enums_1.ActionType.CREATE_ACTIVITY; }
        if (activity_type === void 0) { activity_type = ''; }
        if (field_mappings === void 0) { field_mappings = {}; }
        if (target_entity_ref === void 0) { target_entity_ref = ''; }
        this.action_type = action_type;
        this.activity_type = activity_type;
        this.field_mappings = field_mappings;
        this.target_entity_ref = target_entity_ref;
    }
    ActionBlockConfig.fromJSON = function (json) {
        var config = new ActionBlockConfig();
        if (json) {
            config.action_type = json.action_type || workflow_enums_1.ActionType.CREATE_ACTIVITY;
            config.activity_type = json.activity_type || '';
            // config.template = json.template || {};
            config.field_mappings = json.field_mappings || {};
            config.target_entity_ref = json.target_entity_ref || '';
        }
        return config;
    };
    return ActionBlockConfig;
}());
exports.ActionBlockConfig = ActionBlockConfig;
var DelayBlockConfig = /** @class */ (function () {
    function DelayBlockConfig(duration, unit, description) {
        if (duration === void 0) { duration = 1; }
        if (unit === void 0) { unit = workflow_enums_1.DelayUnit.MINUTES; }
        if (description === void 0) { description = ''; }
        this.duration = duration;
        this.unit = unit;
        this.description = description;
    }
    DelayBlockConfig.fromJSON = function (json) {
        var config = new DelayBlockConfig();
        if (json) {
            config.duration = json.duration || 1;
            config.unit = json.unit || workflow_enums_1.DelayUnit.MINUTES;
            config.description = json.description || '';
        }
        return config;
    };
    return DelayBlockConfig;
}());
exports.DelayBlockConfig = DelayBlockConfig;
var APIBlockConfig = /** @class */ (function () {
    function APIBlockConfig(url, method, headers, body_template, timeout_seconds) {
        if (url === void 0) { url = ''; }
        if (method === void 0) { method = workflow_enums_1.HttpMethod.POST; }
        if (headers === void 0) { headers = {}; }
        if (body_template === void 0) { body_template = ''; }
        if (timeout_seconds === void 0) { timeout_seconds = 30; }
        this.url = url;
        this.method = method;
        this.headers = headers;
        this.body_template = body_template;
        this.timeout_seconds = timeout_seconds;
    }
    APIBlockConfig.fromJSON = function (json) {
        var config = new APIBlockConfig();
        if (json) {
            config.url = json.url || '';
            config.method = json.method || workflow_enums_1.HttpMethod.POST;
            config.headers = json.headers || {};
            config.body_template = json.body_template || '';
            config.timeout_seconds = json.timeout_seconds || 30;
        }
        return config;
    };
    return APIBlockConfig;
}());
exports.APIBlockConfig = APIBlockConfig;
var FilterBlockConfig = /** @class */ (function () {
    function FilterBlockConfig(entity_type, entity_id, activity_type, filter_groups) {
        if (entity_type === void 0) { entity_type = field_1.EntityType.CONTACT; }
        if (entity_id === void 0) { entity_id = ''; }
        if (activity_type === void 0) { activity_type = ''; }
        if (filter_groups === void 0) { filter_groups = new filter_1.FilterGroup(filter_1.LogicOperator.AND); }
        this.entity_type = entity_type;
        this.entity_id = entity_id;
        this.activity_type = activity_type;
        this.filter_groups = filter_groups;
    }
    FilterBlockConfig.fromJSON = function (json) {
        var config = new FilterBlockConfig();
        if (json) {
            config.entity_type = json.entity_type || field_1.EntityType.CONTACT;
            config.entity_id = json.entity_id || '';
            config.activity_type = json.activity_type || '';
            config.filter_groups = json.filter_groups ? filter_1.FilterGroup.fromJSON(json.filter_groups) : new filter_1.FilterGroup(filter_1.LogicOperator.AND);
        }
        return config;
    };
    return FilterBlockConfig;
}());
exports.FilterBlockConfig = FilterBlockConfig;
